import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { registerLocaleData, CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TabsModule } from 'ngx-bootstrap/tabs'
import { ColorPickerModule } from 'ngx-color-picker';

import { AppComponent } from './app.component';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import * as api from '../api';
import * as services from '../app/services';
import { LayoutTaskmasterModule } from './pages/taskmaster/layout-taskmaster.module';
import { OrderItemEditComponent } from './components/order-item-edit/order-item-edit.component';

export const createTranslateLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, './assets/i18n/', '.json');

let providers: any = [];
//added custom services
providers.push(...Object.keys(services).map(key => services[key]));

//added api services
providers.push(...Object.keys(api).map(key => api[key]));

providers.push({ provide: "windowObject", useValue: window });

const routes: Routes = [
  {
    path: ':lang',
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/auth/layout-auth.module').then(m => m.LayoutAuthModule)
      },
      {
        path: 'administrator',
        loadChildren: () => import('./pages/admin/layout-admin.module').then(m => m.LayoutAdministratorModule)
      },
      {
        path: 'auditor',
        loadChildren: () => import('./pages/auditor/layout-auditor.module').then(m => m.LayoutAuditorModule)
      },
      {
        path: 'clinic',
        loadChildren: () => import('./pages/clinic/layout-clinic.module').then(m => m.LayoutClinicModule)
      },
      {
        path: 'techincian',
        loadChildren: () => import('./pages/techincian/layout-techincian.module').then(m => m.LayoutTechincianModule)
      },
      {
        path: 'taskmaster',
        loadChildren: () => import('./pages/taskmaster/layout-taskmaster.module').then(m => m.LayoutTaskmasterModule)
      }
    ]
  },
  { path: '', redirectTo: '/ru', pathMatch: 'full' },
  { path: '**', redirectTo: '/ru' }
];

@NgModule({
  declarations: [
    AppComponent,
    OrderItemEditComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    RouterModule.forRoot(routes),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    HttpClientModule,
    ColorPickerModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    CommonModule,
    BsDatepickerModule.forRoot(),
    TabsModule.forRoot()
  ],
  bootstrap: [AppComponent],
  providers: [providers],
  exports: [
    ColorPickerModule
  ]
})
export class AppModule { }
